import { useEffect, useRef } from "react";

export default function useInterval(callback: () => any, interval: number) {
  const ref = useRef(callback);
  ref.current = callback;

  useEffect(() => {
    const id = setInterval(() => ref.current(), interval);
    return () => clearInterval(id);
  }, [interval]);
}
